export default "__VITE_ASSET__CoIcc6OP__"